import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppShell } from "@/components/layout/app-shell";
import { AdminRoute } from "@/components/admin-route";
import DashboardPage from "@/pages/dashboard";
import StudyHealthPage from "@/pages/study-health";
import ParticipantsPage from "@/pages/participants";
import ParticipantDetailPage from "@/pages/participant-detail";
import DataExplorerPage from "@/pages/data-explorer";
import VisualizationPage from "@/pages/visualization";
import ExportPage from "@/pages/export";
import HelpPage from "@/pages/help";
import Login from "@/pages/login";
import LandingPage from "@/pages/landing";
import PrivacyPolicy from "@/pages/privacy-policy";
import UserManagementPage from "@/pages/admin/user-management";
import DevicesPage from "@/pages/admin/devices";
import SurveyConfigPage from "@/pages/admin/survey-config";
import { ProtectedRoute } from "./lib/utils";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LandingPage />} />
          <Route path="/login/sign-in" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="study-health" element={<StudyHealthPage />} />
              <Route path="participants" element={<ParticipantsPage />} />
              <Route path="participants/:id" element={<ParticipantDetailPage />} />
              <Route path="explorer" element={<DataExplorerPage />} />
              <Route path="visualization" element={<VisualizationPage />} />
              <Route path="export" element={<ExportPage />} />
              <Route path="help" element={<HelpPage />} />

              <Route element={<AdminRoute />}>
                <Route path="admin/users" element={<UserManagementPage />} />
                <Route path="admin/devices" element={<DevicesPage />} />
                <Route path="admin/survey-config" element={<SurveyConfigPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
